export const normalizeArray = (originalValue: any): string[] => 
    Array.isArray(originalValue) ? originalValue.filter((v) => typeof v === 'string' && v.trim()) : [];

export const MixCodesOriginFieldValidation = (values: any) => {
    const { tempParams, params } = values;

    if (!tempParams?.pincodeOriginValitidy) {
        return { isValid: true };
    }

    const campaignIds = normalizeArray(params?.campaignIds);
    const lotIds = normalizeArray(params?.lotIds);

    const isMissingLotIds = lotIds.length === 0 && tempParams.codeType.includes('Pincodes');
    const isMissingCampaignIds = campaignIds.length === 0 && tempParams.codeType.includes('Viral Codes');

    const createValidationError = (module: string, path: string, message: string) => ({
        isValid: false,
        module,
        path,
        message,
    });

    if (isMissingLotIds) {
        return createValidationError("pinCodes", "params.lotIds", "Lot IDs are required when Code origin validation is ticked.");
    }

    if (isMissingCampaignIds) {
        return createValidationError("viral", "params.campaignIds", "Campaign IDs are required when Code origin validation is ticked.");
    }

    return { isValid: true };
};

export default MixCodesOriginFieldValidation;